import httpCommon from "../../http-common";

const getSchoolYears = async () => {
  const schoolYears = await httpCommon.http.get("/config/semester");
  console.log('Got school years', schoolYears);
  return schoolYears?.data?.data;
};

const ConfigService = {
  getSchoolYears,
};

export default ConfigService;